export const SET_DELIVERY_ADDRESS = 'SET_DELIVERY_ADDRESS';
export const CLEAR_DELIVERY_ADDRESS = 'CLEAR_DELIVERY_ADDRESS';
export const FETCH_DELIVERY_ADDRESS_START = 'FETCH_DELIVERY_ADDRESS_START';
export const FETCH_DELIVERY_ADDRESS_SUCCESS = 'FETCH_DELIVERY_ADDRESS_SUCCESS';
export const FETCH_DELIVERY_ADDRESS_FAILURE = 'FETCH_DELIVERY_ADDRESS_FAILURE';